import { ResponsiveBar } from "@nivo/bar"

// 한국식 숫자 포맷터
function formatKoreanNumber(value) {
  if (value >= 1e12) return (value / 1e12).toFixed(1).replace(/\.0$/, "") + "조"
  if (value >= 1e8) return (value / 1e8).toFixed(1).replace(/\.0$/, "") + "억"
  if (value >= 1e4) return (value / 1e4).toFixed(1).replace(/\.0$/, "") + "만"
  return value?.toString() ?? "0"
}

export default function NivoHorizontalBar({
  data,
  keys = ["value"],
  indexBy = "id",
  title,
  height = 400,
}) {
  if (!data || !data.length) {
    return <p>No data available</p>
  }
    const palette = [
    "#9adbf9", 
    "#f9a97b", 
    "#f78bbd", 
    "#8ea9e6", 
    "#c8e48c", 
    "#5ca5c2", 
    "#66d19e", 
    "#a0a0a0", 
    "#b798e0",
    ]


  return (
    <div className="w-full">
      {title && (
        <h3 className="text-lg font-semibold mb-2 text-left">{title}</h3>
      )}
      <div style={{ height }}>
        <ResponsiveBar
          data={data}
          keys={keys}
          indexBy={indexBy}
          layout="horizontal"
          groupMode="grouped"
          margin={{ top: 40, right: 40, bottom: 50, left: 150 }}
          padding={0.3}
          valueScale={{ type: "linear" }}
          indexScale={{ type: "band", round: true, reverse: true }}
          colors={({ index }) => palette[index % palette.length]}
          borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            legend: "",
            legendPosition: "middle",
            legendOffset: 40,
            format: formatKoreanNumber,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 10,
            truncateTickAt: 0, 
          }}
          label={(d) => formatKoreanNumber(d.value)}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
          
          tooltip={({ id, value, indexValue, color }) => (
            <div
              style={{
                padding: "8px 10px",
                background: "white",
                border: `1px solid ${color}`,
                borderRadius: "6px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                fontSize: 12,
              }}
            >
              <div style={{ fontWeight: 600, color }}>
                ● {indexValue}
              </div>
              <div>{id}: {formatKoreanNumber(value)}</div>
            </div>
          )}
        />
      </div>
    </div>
  )
}
